module.exports = __webpack_public_path__ + "static/img/nmgrm.9cc5459.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/nmgrm.png
// module id = qZ2k
// module chunks = 0